
import AppBrowse from "@/components/browse/Browse.vue";
import { BrowseService } from "@/services/browse-service";
import { ToolbarService } from "@/services/toolbar-service";
import { IBrowseDataSource } from "@/utils/browse/browse-data-source";
import Vue from "vue";
import { UserConfigService } from "../../services/user-config-service";
import { View } from "@/models/view";
import { FetchedTotal } from "@/utils/views/fetched-total";
import { IQueryParams } from "@/utils/query-params";
import { checkHasModule } from "@/router";
import { MODULE } from "@/config/modules";
import { DiverseLedger } from "@/models/base/diverse-ledger";
import { DiverseLedgerService } from "@/services/diverse-ledgers-service";

export default Vue.extend({
	data() {
		return {
			selectedItems: [] as DiverseLedger[],
		};
	},
	props: {
		browseId: Number,
	},
	computed: {
		dataSource(): IBrowseDataSource<DiverseLedger> {
			let elem = this;
			return {
				getFullElement: async (el:DiverseLedger)=>el,
				getSettings: () => BrowseService.getBrowse(this.browseId),
				getElements: (params: IQueryParams) => DiverseLedgerService.getDiverseLedgers(params),
				getTotals(view:View):Promise<FetchedTotal[]>{
					return DiverseLedgerService.getTotals(view);
				},
				edit(ledger: DiverseLedger) {
					elem.$router.push({path: `/diverse-ledgers/edit/${ledger.ID}`});
				},
				async delete(ledger: DiverseLedger[]) {
					await DiverseLedgerService.delete(ledger);
					return true;
				},
				addRoute: `/diverse-ledgers/new`,
				browseName: "DiverseLedger",
				modelName: "DiverseLedger",
				browsePermissions: () => UserConfigService.getPermissionSettings().SalePermissions
			};
		},
	},
	methods: {
		refresh(){
			let browse = this.$refs.browse as any;
			if (!browse) return;
			browse.refresh();
		},
	},
	mounted() {
		ToolbarService.title = this.$ct("diverse-ledgers");
	},
	created(){
		if (!checkHasModule(MODULE.BOEKHOUDLIJSTEN, this.$router)){
			throw new Error("MISSING MODULE");
		}
	},
	components: {
		AppBrowse
	},
	i18nEx: {
		componentPrefix: "components.diverse-ledgers"
	},
});
